// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"airplay-wave"},"nodeName":"g","children":[{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M5.5 19H2.00099L2 4H22L22 19L18.5 19","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M6.34375 12.6762C9.46794 9.55196 14.5333 9.55196 17.6575 12.6762M9.17188 15.5036C10.734 13.9415 13.2666 13.9415 14.8287 15.5036M10.5 21L12 19.5L13.5 21L10.5 21Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-airplay-wave')
export default class AirplayWaveIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'airplay-wave',
    }
  }
}
